/* global axios */
import ApiClient from './ApiClient';
import { sharedRequest } from './sharedRequest';

class CustomViewsAPI extends ApiClient {
  constructor() {
    super('custom_filters', { accountScoped: true });
  }

  getCustomViewsByFilterType(type) {
    const url = `${this.url}?filter_type=${type}`;
    return sharedRequest(url, () => axios.get(url));
  }

  deleteCustomViews(id, type) {
    return axios.delete(`${this.url}/${id}?filter_type=${type}`);
  }
}

export default new CustomViewsAPI();
